// Import all translation modules
import { common } from './common';
import { auth } from './auth';
import { homepage } from './homepage';
import { cars as carsModule } from './cars';
import { customer } from './customer';
import { agency } from './agency';
import { admin } from './admin';
import { dashboard } from './dashboard';
import { vehicles } from './vehicles';
import { calendar } from './calendar';
import { privacy } from './privacy';

// Create Arabic bookings translations
export const bookings = {
  title: 'الحجوزات',
  subtitle: 'إدارة حجوزات الإيجار',
  newBooking: 'حجز جديد',
  editBooking: 'تعديل الحجز',
  customer: 'العميل',
  selectCustomer: 'اختر العميل',
  createNewCustomer: 'إنشاء عميل جديد',
  searchCustomer: 'البحث بالاسم أو رقم الهوية...',
  vehicle: 'المركبة',
  selectVehicle: 'اختر المركبة',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ النهاية',
  pickupTime: 'وقت الاستلام',
  returnTime: 'وقت الإرجاع',
  depositAmount: 'مبلغ الوديعة',
  totalPrice: 'السعر الإجمالي',
  notes: 'ملاحظات',
  days: 'أيام',
  edit: 'تعديل',
  allStatuses: 'جميع الحالات',
  totalBookings: '{{count}} حجز',
  noBookingsFound: 'لم يتم العثور على حجوزات',
  noBookings: 'لا توجد حجوزات حتى الآن',
  tryDifferentFilter: 'جرب تعديل البحث أو الفلاتر',
  noBookingsDesc: 'ابدأ بإنشاء أول حجز لك',
  createFirstBooking: 'إنشاء أول حجز',
  selectDatePlaceholder: 'اختر تاريخاً',
  timePlaceholder: 'اختر الوقت',
  status: {
    pending: 'في الانتظار',
    confirmed: 'مؤكد',
    completed: 'مكتمل',
    cancelled: 'ملغي'
  }
};

// Export organized Arabic translations
export const ar = {
  translation: {
    ...common,
    auth,
    homepage,
    cars: carsModule,
    carsPage: carsModule,
    customer,
    agency,
    admin,
    dashboard,
    vehicles,
    calendar,
    bookings,
    privacy,
    
    // Override to fix naming conflict - preserve navigation keys from common
    dashboardNav: 'لوحة التحكم',
    
    // Properly nest common translations under 'common' key
    common: {
      ...common,
      // Legacy keys for backward compatibility (can be removed after migration)
      comingSoon: 'قريباً',
      error: 'خطأ',
      retry: 'إعادة المحاولة',
      status: 'الحالة',
    },
    
    // Agencies page translations
    agenciesPage: {
      searchAgencies: 'البحث عن الوكالات بالاسم أو المدينة...',
      allCities: 'جميع المدن',
      agencyFound: 'وكالة موجودة',
      agenciesFound: 'وكالة موجودة',
      carsAvailable: 'السيارات',
      locations: 'المواقع',
      viewDetails: 'عرض التفاصيل',
      noAgenciesFound: 'لم يتم العثور على وكالات',
      adjustSearchCriteria: 'حاول تعديل معايير البحث أو امسح المرشحات لرؤية المزيد من النتائج.',
      contactForHours: 'اتصل للحصول على الساعات',
      varyingHours: 'ساعات متغيرة',
    },
  }
}; 